import { render } from "./SecCards.vue?vue&type=template&id=17589452&scoped=true"
import script from "./SecCards.vue?vue&type=script&lang=js"
export * from "./SecCards.vue?vue&type=script&lang=js"

import "./SecCards.vue?vue&type=style&index=0&id=17589452&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17589452"]])

export default __exports__